/**
 * @file Hide.tsx
 *
 * @fileoverview Hides elements from printing.
 */

import styles from './print.module.scss';

interface PrintHideProps {
  children: React.ReactNode;
}

export const PrintHide = ({ children }: PrintHideProps) => (
  <div className={styles.hidePrintResume}>{children}</div>
);

export default PrintHide;
